/**
 * Stable CSS class names for E2E — Order detail page.
 */
export const OD = {
    pageRoot: 'order-detail-page',
    loadingGrid: 'order-detail-page__loading-grid',
    loadingInner: 'order-detail-page__loading-inner',
    contentWrap: 'order-detail-page__content',
    detailsWrap: 'order-detail-page__details-wrap',
    noRecordWrap: 'order-detail-page__no-record-wrap',
} as const;

